import {
  AfterViewInit,
  Component,
  DestroyRef,
  effect,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NgClass } from '@angular/common';
import { LayoutService } from '../layout-service';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { SideMenu } from '../side-menu/side-menu';
import { Session } from '../../../core/services/session/session';
import { StorageService } from '../../../core/services/storage/storage';
import { SharedApis } from '../../../core/services/shared-apis/shared-apis';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DelegatedUIErrorI } from '../../shared/interfaces/delegated-ui-error.interface';
import { ToastService } from '../../../core/services/toast/toast.service';

@Component({
  selector: 'app-base',
  imports: [Header, RouterOutlet, Footer, SideMenu, NgClass],
  templateUrl: './base.html',
  styleUrl: './base.scss',
})
export class Base implements AfterViewInit, OnInit {
  @ViewChild('base')
  public base?: ElementRef<HTMLDivElement>;
  private readonly layoutService = inject(LayoutService);
  private readonly sessionService = inject(Session);
  private readonly storageService = inject(StorageService);
  private readonly sharedApisService = inject(SharedApis);
  private readonly toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  resizeObserver?: ResizeObserver;
  constructor() {
    this.screenWidth = window.innerWidth;
    effect(() => {
      this.toggleSideMenu();
    });
  }
  ngAfterViewInit(): void {
    if (this.base?.nativeElement) {
      this.resizeObserver = new ResizeObserver((entries) => {
        const width = entries[0].contentRect.width;
        this.screenWidth = width;

        if (width <= 720) {
          if (!this.layoutService.isSideMenuCollapsed()) {
            this.layoutService.isSideMenuCollapsed.set(true);
          }
        }
      });

      this.resizeObserver.observe(this.base.nativeElement);
    }
  }
  ngOnInit(): void {
    this.findLoggedInUser();
  }

  findLoggedInUser() {
    const loggedInUser = this.storageService.loggedInUser;

    this.sharedApisService
      .findLoggedInUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (findLoggedInUserResponse) => {
          const { data } = findLoggedInUserResponse;
          this.sessionService.addLoggedInUser(data);

          if (JSON.stringify(loggedInUser) === JSON.stringify(data)) {
            return;
          }

          this.storageService.loggedInUser = data;
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }

  isCollapsed = signal<boolean>(false);
  screenWidth: number;

  toggleSideMenu() {
    this.isCollapsed.update(() => this.layoutService.isSideMenuCollapsed());
  }
}
